import Link from 'next/link';
import Image from 'next/image';
import { IconBrandInstagram } from '@tabler/icons-react';
import { IInstagramPost } from '@/interfaces/homepage';

interface Props {
  post: IInstagramPost;
}

export function InstagramPost({ post }: Props) {
  return (
    <a data-testid="instagram-item" href={post.RedirectionUrl} target="_blank" rel="noopener noreferrer">
      <div className="group relative aspect-square cursor-pointer overflow-hidden bg-gray-200">
        <Image src={post.ImageUrl} alt="Instagram post" fill className="h-full w-full object-cover" priority />

        {/* overlay */}
        <div className="absolute left-0 top-0 z-30 h-full w-full bg-black/20" />

        {/* animated instagram icon */}
        <div className="absolute left-3 top-3 z-[38] transition-all duration-300 ease-in-out group-hover:left-1/2 group-hover:top-1/2 group-hover:-translate-x-1/2 group-hover:-translate-y-1/2 group-hover:scale-[6] md:group-hover:scale-[4]">
          <IconBrandInstagram size={32} className="text-white" />
        </div>
      </div>
    </a>
  );
}
